/* eslint-disable react/no-danger */
const BookingFieldLabel = ({ html }) => (
  <span dangerouslySetInnerHTML={{ __html: html }} />
);

export default BookingFieldLabel;
